import { setTerms } from './helpers';

export const setHeatingTypes = setTerms('heating_source_type');
